import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n/LanguageContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <section className="relative py-10 sm:py-14 bg-[var(--page)] border-y border-[var(--hairline)] overflow-hidden" aria-hidden="true">
      <Marquee speed={38} gradient={false} autoFill>
        {t.marquee.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-[var(--ink)] opacity-20 text-4xl sm:text-6xl px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-terra/40" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};
